import React from 'react'
import { useStoreon } from 'storeon/react'
import { ModalExitChange } from '@/apps/Applications/components/ModalExitChange'
import { ModalEntryChange } from '@/apps/Applications/components/ModalEntryChange'
import ModalPayCertificateOrDeposit from '../../apps/Applications/components/ModalPayCertificateOrDeposit'
import ModalUser from '../../apps/Applications/components/ModalUser'
import useModal from '../../hooks/useModal'
import ModalCreateTask from '../../apps/Applications/components/ModalCreateTask'
import ModalComment from '../../apps/Applications/components/ModalComment'
import ModalPhoneCall from '../ModalPhoneCall'
import { ModalCommentChange } from '../../apps/Applications/components/ModalCommentChange'

const MODAL_TYPES: any = {
  modalUser: ModalUser,
  modalCreateTask: ModalCreateTask,
  modalPayCertificateOrDeposit: ModalPayCertificateOrDeposit,
  modalComment: ModalComment,
  modalPhoneCall: ModalPhoneCall,
  modalCommentChange: ModalCommentChange,
  modalExitTimeChange: ModalExitChange,
  modalEntryTimeChange: ModalEntryChange,
  empty: () => null
}

const Modals = () => {
  const { closeModal } = useModal()
  const { showModal, props } = useStoreon('showModal', 'props')
  const CurrentModal = MODAL_TYPES[showModal]

  return <CurrentModal flag={!!showModal} onRequestClose={closeModal} props={props} />
}

export default Modals
